import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	padding: 60px 0 60px 60px;
`;

const StyledPanelControlsContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 80px;
`;

const StyledStepButtons = styled.div<{ $buttonCount: number }>`
	position: absolute;
	left: 0;
	bottom: 30px;
	display: grid;
	grid-template-columns: repeat(${(props) => props.$buttonCount}, 1fr);
	gap: 20px;
	width: 100%;
	padding: 0 30px;
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 80px;
	right: 80px;
	display: flex;
	gap: 40px;
`;
export {
	StyledContainer,
	StyledPanelControlsContainer,
	StyledStepButtons,
	StyledRightContainer,
};
